module.exports = __webpack_public_path__ + "static/img/card-box.ff859c0f.png";